export const EXCLUDED_DELIVERY_PINCODES = [
  "111111",
  "414141",
];

const normalizePincode = (pincode) => String(pincode || "").replace(/\D/g, "").slice(0, 6);

const EXCLUDED_PINCODE_SET = new Set(EXCLUDED_DELIVERY_PINCODES.map(normalizePincode));

export const isExcludedDeliveryPincode = (pincode) => EXCLUDED_PINCODE_SET.has(normalizePincode(pincode));
